import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useService } from '../../../../shared/hooks/useService';
import { useAlert } from '../../../../shared/hooks/useAlert';
import ForgotPasswordForm from '../../components/ForgotPasswordForm';

const ForgotPasswordPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const service = useService();
    const navigate = useNavigate();
    const { alert, showSuccess, showError, hideAlert } = useAlert();

    const handleRequestCode = async (email) => {
        setIsLoading(true);
        try {
            await service.forgotPassword(email);
            showSuccess('Verification code sent. Check your email.');
            return true;
        } catch (error) {
            showError(error.message || 'Failed to send verification code');
            return false;
        } finally {
            setIsLoading(false);
        }
    };

    const handleConfirmReset = async (email, code, newPassword) => {
        setIsLoading(true);
        try {
            await service.confirmForgotPassword(email, code, newPassword);
            navigate('/login', { state: { successMessage: 'Password reset successfully. You can now log in.' } });
        } catch (error) {
            showError(error.message || 'Failed to reset password');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="mt-5">
            <ForgotPasswordForm
                onRequestCode={handleRequestCode}
                onConfirmReset={handleConfirmReset}
                isLoading={isLoading}
                alert={alert}
                onAlertClose={hideAlert}
            />
        </Container>
    );
};

export default ForgotPasswordPage;
